import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'

const RegistrationPageGuard = ({ children, navigation }) => {
	const [isLoading, setIsLoading] = useState(true)
	const [registrationClosed, setRegistrationClosed] = useState(false)
	const [error, setError] = useState()
	const navigate = useNavigate()

	useEffect(() => {
		const checkRegistrationStatus = async () => {
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/settings/registerYourTeam`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(
						responseData.message || 'Could not check team registration status.',
					)
				}

				setRegistrationClosed(responseData.hide === true)
			} catch (err) {
				console.log(err)

				// Fail closed: if the status cannot be checked,
				// do not allow roster changes.
				setError(err.message)
				setRegistrationClosed(true)
			} finally {
				setIsLoading(false)
			}
		}

		checkRegistrationStatus()
	}, [])

	if (isLoading) {
		return <LoadingSpinner asOverlay />
	}

	if (registrationClosed) {
		return (
			<>
				{navigation}

				<div
					style={{
						maxWidth: '700px',
						margin: '5rem auto',
						padding: '2rem',
						textAlign: 'center',
					}}
				>
					<h2>Team Registration Is Closed</h2>

					<p>Team registrations and roster changes are currently disabled.</p>

					{error && (
						<p style={{ fontSize: '0.9rem' }}>
							The registration status could not be verified.
						</p>
					)}

					<button type='button' onClick={() => navigate('/')}>
						Return Home
					</button>
				</div>
			</>
		)
	}

	return (
		<>
			{navigation}
			{children}
		</>
	)
}

export default RegistrationPageGuard
